import React from 'react';
import Modal from '../../CommonComponents/Modal';

interface Props {
  currentReturn: string;
  recommendedReturn: string;
  isOpen: boolean;
  onRequestClose: () => void;
}

export const Disclosures: React.FC<Props> = ({
  currentReturn,
  recommendedReturn,
  isOpen,
  onRequestClose,
}) => (
  <Modal className="modal" isOpen={isOpen} onRequestClose={onRequestClose}>
    <div className="closerdiv" style={{ paddingTop: '50px' }}>
      <div id="ExpressWizard_Disclosures" className="popup" style={{ display: 'block' }}>
        <h2>
          Disclosures &amp; Assumptions
          <i className="fa fa-times close" onClick={onRequestClose} />
        </h2>
        <p>
          The current simulation is based on a fixed return of {currentReturn} while the
          hypothetical simulation is based on a fixed return of {recommendedReturn}. Any changes
          between the two are a result of an assumed additional retirement contribution from excess
          cash flows. The hypothetical allocation you see here is not intended to be a
          recommendation, the simulation does not reflect actual investment results, and the
          projections are not guarantees of future results. To assess what portfolio mix is right
          for you, please speak to your financial advisor. The output from this calculator may vary
          with each use and over time. For income taxes, we are assuming a federal tax withholding
          of 22%. For a more accurate assessment of your tax liability, please speak to your
          accountant. Retirement contributions are saved on a tax deferred basis. The tool does not
          consider specific securities held by you and does not therefore attempt to predict the
          future value of any specific securities. This calculator provides analysis based on your
          input but makes many additional assumptions.
        </p>
      </div>
    </div>
  </Modal>
);
